export const FORM_VIEW = {
  SIGN_IN: 'signIn',
  FORGOT_USERNAME: 'forgotUsername',
  FORGOT_PASSWORD: 'forgotPassword'
};

const signInSchema = {
  username: {
    presence: {
      allowEmpty: false,
      message: 'is required'
    }
  },

  password: {
    presence: {
      allowEmpty: false,
      message: 'is required'
    }
  }
};

const forgotUsernameSchema = {
  email: {
    presence: {
      allowEmpty: false,
      message: 'is required'
    },

    email: {
      message: 'is not valid'
    }
  }
};

const forgotPasswordSchema = {
  username: {
    presence: {
      allowEmpty: false,
      message: 'is required'
    }
  },

  email: {
    presence: {
      allowEmpty: false,
      message: 'is required'
    },

    email: {
      message: 'is not valid'
    }
  }
};

export const getSchema = view => {
  switch (view) {
    case FORM_VIEW.FORGOT_USERNAME:
      return forgotUsernameSchema;

    case FORM_VIEW.FORGOT_PASSWORD:
      return forgotPasswordSchema;

    default:
      return signInSchema;
  }
};

export const getInitialFormState = view => {
  switch (view) {
    case FORM_VIEW.FORGOT_USERNAME:
      return {
        errors: {},
        isValid: false,
        touched: {},
        values: {
          email: ''
        }
      };

    case FORM_VIEW.FORGOT_PASSWORD:
      return {
        errors: {},
        isValid: false,
        touched: {},
        values: {
          email: '',
          username: ''
        }
      };

    default:
      return {
        errors: {},
        isValid: false,
        touched: {},
        values: {
          password: '',
          username: ''
        }
      };
  }
};